import { Link } from '@chegg-ui/link'
import React from 'react'
import { EMAIL_LINK } from './constants'

export const AutoRenewalText = (freeTrial = true, price = '$9.95') => {
  return (
    `Autorenewal: Your subscription 
      ${freeTrial ? 'begins at the end of the 3-day free trial and ' : ''}` +
    `renews automatically on a rolling monthly basis. You consent to Chegg
      automatically charging the payment method on file the monthly subscription
      cost of USD${price} plus applicable tax per month each month until you cancel your
      subscription. To the extent permitted by law, subscription fees are not
      refundable.`
  )
}

export const CancellationText = (supportLink: string) => (
  <>
    Cancellation: You can cancel your subscription at any time by visiting our{' '}
    <Link href={supportLink}>Support Page</Link> and completing the steps to cancel or by
    emailing <Link href={EMAIL_LINK}>wtsupport@chegg.com</Link>. Cancellations will take
    effect at the next billing period. Following cancellation, you will continue to have
    access to your subscription until the end of your current billing period.
  </>
)
